import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const NavButton = styled.div`
    font-style: italic;
    font-size: 1rem;
    margin: 0.15rem 0.75rem 0.25rem;
    cursor: pointer;
    color: #888888;
    user-select: none;
    vertical-align: middle;
    &:hover {
        color: #444444;
        font-weight: bold;
        text-decoration: underline;
    }
`;

const NavWrapper = styled.div`
    background-color: #eeeeee;
    height: 1.75rem;
`;

const NavPrevious = styled(NavButton)`
    float: left;
`;

const NavNext = styled(NavButton)`
    float: right;
`;

export class VideoNavigation extends Component {

    static propTypes = {
        on_change: PropTypes.func.isRequired,
        item_count: PropTypes.number.isRequired,
        item_index: PropTypes.number.isRequired,
    }

    render() {
        const {on_change, item_count, item_index} = this.props;
        return <NavWrapper>
            <NavPrevious onClick={e => on_change((item_index - 1 + item_count) % item_count)}>
                previous
            </NavPrevious>
            <NavNext onClick={e => on_change((item_index + 1 + item_count) % item_count)}>
                next
            </NavNext>
        </NavWrapper>
    }
}

export default VideoNavigation;